/*
 * WARNING: THIS IS AN AUTOGENERATED-FILE. DO NOT MANUALLY EDIT THIS FILE.
 *
 * MODIFY FLAGS DATA IN etc/features.yaml AND RUN `bundle exec bin/generate-ts-constants`
 * TO REGENERATE THIS FILE.
 */

export enum Feature {
  ProdEnvironmentIndicator = "ProdEnvironmentIndicator",
  ColumnHooks = "ColumnHooks",
  EventHooks = "EventHooks",
  AllowRemoveLogo = "AllowRemoveLogo",
  AdvancedBranding = "AdvancedBranding",
  I18N = "I18N",
  ValidationWebhooks = "ValidationWebhooks",
  Headless = "Headless",
  HeadlessValidation = "HeadlessValidation",
  DynamicTemplates = "DynamicTemplates",
  AuditLogs = "AuditLogs",
  ExtendedMetadataWebhookTimeout = "ExtendedMetadataWebhookTimeout",
  AdvancedMappings = "AdvancedMappings",
  CustomEnvironments = "CustomEnvironments",
  CodeHooksV1 = "CodeHooksV1",
  Integrations = "Integrations",
  TestMaskDataHighlighting = "TestMaskDataHighlighting",
  InAppBilling = "InAppBilling",
  ValidationWebhooksUnmappedCols = "ValidationWebhooksUnmappedCols",
  UserRoleManagement = "UserRoleManagement",
  SelfServeTrial = "SelfServeTrial",
  SuggestedTransforms = "SuggestedTransforms",
  ShowApiTemplateHooks = "ShowApiTemplateHooks",
  TemplateJsonHooksField = "TemplateJsonHooksField",
  PosthogDisabled = "PosthogDisabled",
  RelationalValidations = "RelationalValidations",
  LegacyForbiddenErrorCode = "LegacyForbiddenErrorCode",
  LegacyValidationHooksAuthType = "LegacyValidationHooksAuthType",
  EmailLoginWithSso = "EmailLoginWithSso",
  ExternalAPI = "ExternalAPI",
  EnableGetTemplatesExtApi = "EnableGetTemplatesExtApi",
  UsageAndBilling = "UsageAndBilling",
  ConnectionsS3 = "ConnectionsS3",
  ConnectionsGcs = "ConnectionsGcs",
  ConnectionsSqlServer = "ConnectionsSqlServer",
  ConnectionsPostgres = "ConnectionsPostgres",
  ConnectionsAwsSecretsManager = "ConnectionsAwsSecretsManager",
  ConnectionsAzureKeyVault = "ConnectionsAzureKeyVault",
  ConnectionsAzureBlob = "ConnectionsAzureBlob",
  ConnectionsSalesforce = "ConnectionsSalesforce",
  ByokLlmProviders = "ByokLlmProviders",
  WorkflowsSalesforcePush = "WorkflowsSalesforcePush",
  WorkflowsS3Push = "WorkflowsS3Push",
  WorkflowsSalesforceSchemaFetch = "WorkflowsSalesforceSchemaFetch",
  WorkflowsSalesforceDataFetch = "WorkflowsSalesforceDataFetch",
  McpServer = "McpServer",
  FrontendValidationWebhookTimeoutSeconds = "FrontendValidationWebhookTimeoutSeconds",
  FrontendValidationPollTimeoutSeconds = "FrontendValidationPollTimeoutSeconds",
  GlobalFiles = "GlobalFiles",
  DisableEmailLogin = "DisableEmailLogin",
  HideImportActivityPreview = "HideImportActivityPreview",
  TemplateColumnsOrder = "TemplateColumnsOrder",
  LockColumns = "LockColumns",
  ServerReachabilityPing = "ServerReachabilityPing",
  DebugTemplatesEndpointLag = "DebugTemplatesEndpointLag",
  DisableDateAutoFormatting = "DisableDateAutoFormatting",
  MalwareFileScan = "MalwareFileScan",
  ParallelValidationCodeHooks = "ParallelValidationCodeHooks",
  LargeFileImportTimeout = "LargeFileImportTimeout",
  ConnectionUploadTimeout = "ConnectionUploadTimeout",
  A11yUserwayWidget = "A11yUserwayWidget",
  OperationalMode = "OperationalMode",
  DebugEntities = "DebugEntities",
  InternalApiAuthHeaderAccess = "InternalApiAuthHeaderAccess",
  OrgUsageRecord = "OrgUsageRecord",
  InternalFeatures = "InternalFeatures",
  PauseScheduledDeleteEmbeds = "PauseScheduledDeleteEmbeds",
  HuronRoles = "HuronRoles",
  HuronJwt = "HuronJwt",
  HuronImportsViewFeatures = "HuronImportsViewFeatures",
  ImporterExportParquet = "ImporterExportParquet",
  ImporterEventSnapshots = "ImporterEventSnapshots",
  CustomizationCustomStylesheet = "CustomizationCustomStylesheet",
  PreferCaseSensitivePicklistMatch = "PreferCaseSensitivePicklistMatch",
  WorkspacesV1 = "WorkspacesV1",
  NestedFolders = "NestedFolders",
  WorkspacesExternalCollaborators = "WorkspacesExternalCollaborators",
  FileFeeds = "FileFeeds",
  FileFeedIngestionHooks = "FileFeedIngestionHooks",
  EmbeddedPipelineBuilder = "EmbeddedPipelineBuilder",
  FileFeedWarningsTriggerPartialImport = "FileFeedWarningsTriggerPartialImport",
  MultiUseSftpPath = "MultiUseSftpPath",
  PipelineStepRunPostMappingHooks = "PipelineStepRunPostMappingHooks",
  ForceRunPostMappingHooks = "ForceRunPostMappingHooks",
  ForceRunPostUploadHooks = "ForceRunPostUploadHooks",
  FileFeedsSavedMappings = "FileFeedsSavedMappings",
  Workflows = "Workflows",
  WorkflowsS3Source = "WorkflowsS3Source",
  WorkflowsS3Destination = "WorkflowsS3Destination",
  WorkflowsGcsSource = "WorkflowsGcsSource",
  WorkflowsPreserveSourceFolders = "WorkflowsPreserveSourceFolders",
  WorkflowsGcsDestination = "WorkflowsGcsDestination",
  WorkflowsAzureBlobSource = "WorkflowsAzureBlobSource",
  WorkflowsAzureBlobDestination = "WorkflowsAzureBlobDestination",
  WorkflowsSqlServerSource = "WorkflowsSqlServerSource",
  WorkflowsCsvAgent = "WorkflowsCsvAgent",
  WorkflowsRuntimeCsvAgent = "WorkflowsRuntimeCsvAgent",
  WorkflowsRuntimeCsvAgentReferenceInput = "WorkflowsRuntimeCsvAgentReferenceInput",
  WorkflowsDuckdbSql = "WorkflowsDuckdbSql",
  WorkflowsSplitMergeDuckdb = "WorkflowsSplitMergeDuckdb",
  WorkflowsFileTransformAgent = "WorkflowsFileTransformAgent",
  WorkflowsTemplateAgent = "WorkflowsTemplateAgent",
  WorkflowsFeedBuilderAgent = "WorkflowsFeedBuilderAgent",
  WorkflowsAiCodeReview = "WorkflowsAiCodeReview",
  WorkflowsCustomFileValidation = "WorkflowsCustomFileValidation",
  WorkflowsTrackCredits = "WorkflowsTrackCredits",
  WorkflowsPdfExtraction = "WorkflowsPdfExtraction",
  WorkflowsValidateAgainstTemplate = "WorkflowsValidateAgainstTemplate",
  WorkflowsImportV2 = "WorkflowsImportV2",
  ImportNodeOutputsAsReferences = "ImportNodeOutputsAsReferences",
  WorkflowsDemo = "WorkflowsDemo",
  WorkflowsAiClassifyValues = "WorkflowsAiClassifyValues",
  WorkflowsAiExtractData = "WorkflowsAiExtractData",
  WorkflowsPdfContentSplit = "WorkflowsPdfContentSplit",
  WorkflowsPdfContentSplitAsync = "WorkflowsPdfContentSplitAsync",
  WorkflowsNoHeaderDetection = "WorkflowsNoHeaderDetection",
  WorkflowsKeepBlankRows = "WorkflowsKeepBlankRows",
  WorkflowsParallelExecution = "WorkflowsParallelExecution",
  WorkflowsFlowgraphNodeRunQueue = "WorkflowsFlowgraphNodeRunQueue",
  WorkflowsPrependImportToQueue = "WorkflowsPrependImportToQueue",
  WorkflowsPrioritizePulledImports = "WorkflowsPrioritizePulledImports",
  WorkflowsSingleActiveRun = "WorkflowsSingleActiveRun",
  WorkflowsXlsxHtmlPreview = "WorkflowsXlsxHtmlPreview",
  WorkflowsPreviewPdfJs = "WorkflowsPreviewPdfJs",
  WorkflowsTextOutputLightIndex = "WorkflowsTextOutputLightIndex",
  WorkflowsProcessingType = "WorkflowsProcessingType",
  WorkflowsGoogleSheetsFetch = "WorkflowsGoogleSheetsFetch",
  WorkflowsGoogleDriveFetch = "WorkflowsGoogleDriveFetch",
  WorkflowsGoogleDriveSource = "WorkflowsGoogleDriveSource",
  WorkflowsAzureSharepointFetch = "WorkflowsAzureSharepointFetch",
  WorkflowsAzureSharepointSource = "WorkflowsAzureSharepointSource",
  WorkflowsAzureSharepointDestination = "WorkflowsAzureSharepointDestination",
  WorkflowsDecryptFile = "WorkflowsDecryptFile",
  WorkflowsInternalErrorDetails = "WorkflowsInternalErrorDetails",
  AiFeatures = "AiFeatures",
  ImporterFixWithAi = "ImporterFixWithAi",
  WorkspacesFixWithAi = "WorkspacesFixWithAi",
  AvailableLlmProviders = "AvailableLlmProviders",
  AiCodeGeneration = "AiCodeGeneration",
  AgenticMapping = "AgenticMapping",
  ImporterPdfExtract = "ImporterPdfExtract",
  ImporterPdfExtractionAttribution = "ImporterPdfExtractionAttribution",
  AiMapping = "AiMapping",
  TemplateTags = "TemplateTags",
  GithubSync = "GithubSync",
  DenoTimeoutSeconds = "DenoTimeoutSeconds",
  DuckdbMemoryMib = "DuckdbMemoryMib",
  WorkflowsCsvAgentMaxRows = "WorkflowsCsvAgentMaxRows",
  CsvAgentMaxInputFileBytes = "CsvAgentMaxInputFileBytes",
  BlockEntityDeletion = "BlockEntityDeletion",
  SplitListMaxRows = "SplitListMaxRows",
  WorkflowsTranscode = "WorkflowsTranscode",
  WorkflowsFlowgraphExport = "WorkflowsFlowgraphExport",
  WorkflowsFlowgraphImport = "WorkflowsFlowgraphImport",
  SidekiqThrottleConfig = "SidekiqThrottleConfig",
  DbPoolConfig = "DbPoolConfig",
  WorkflowsFileAgentMaxIterations = "WorkflowsFileAgentMaxIterations",
  CodeHookTimeoutSeconds = "CodeHookTimeoutSeconds",
  WebhookTimeoutSeconds = "WebhookTimeoutSeconds",
  ExternalServiceTimeoutSeconds = "ExternalServiceTimeoutSeconds",
  PdfExtractionTimeoutSeconds = "PdfExtractionTimeoutSeconds",
  PdfExtractionMaxOutputTokens = "PdfExtractionMaxOutputTokens",
  NodeRunTimeoutSeconds = "NodeRunTimeoutSeconds",
  WorkflowRunStaleHours = "WorkflowRunStaleHours",
  WorkflowsRunHeartbeatIntervalSeconds = "WorkflowsRunHeartbeatIntervalSeconds",
  WorkflowsRunHeartbeatMaxAgeSeconds = "WorkflowsRunHeartbeatMaxAgeSeconds",
  WorkflowsRunHealthEnforceMarking = "WorkflowsRunHealthEnforceMarking",
  WorkflowsPauseOnShutdown = "WorkflowsPauseOnShutdown",
  WorkflowsPauseManual = "WorkflowsPauseManual",
  WorkflowsPauseHumanReview = "WorkflowsPauseHumanReview",
  CodeGenerationTimeoutSeconds = "CodeGenerationTimeoutSeconds",
  DisableAutoLayoutInMigrate = "DisableAutoLayoutInMigrate",
  IncreasedSmartMappingUniqueValuesLimit = "IncreasedSmartMappingUniqueValuesLimit",
  WorkflowsAutoBuildValidateRename = "WorkflowsAutoBuildValidateRename",
  WorkflowsSqlServerFetch = "WorkflowsSqlServerFetch",
  WorkflowsGcsFetch = "WorkflowsGcsFetch",
  RustGetTimeoutSeconds = "RustGetTimeoutSeconds",
  RustBulkheadReservedThreads = "RustBulkheadReservedThreads",
  PylonChat = "PylonChat",
  PylonChatJwt = "PylonChatJwt",
  WorkflowsTransformsApi = "WorkflowsTransformsApi",
  WorkflowsShowInitializedImports = "WorkflowsShowInitializedImports",
  WorkflowsAgentEditor = "WorkflowsAgentEditor",
  WorkflowsInspectWithCode = "WorkflowsInspectWithCode",
  WorkflowsStatsPage = "WorkflowsStatsPage",
  WorkflowsResourceUsage = "WorkflowsResourceUsage",
  WorkflowsResourceUsageExternal = "WorkflowsResourceUsageExternal",
  WorkflowsImportRunModal = "WorkflowsImportRunModal",
  WorkflowsNativeExcelShadow = "WorkflowsNativeExcelShadow",
  WorkflowsNativeExcelServe = "WorkflowsNativeExcelServe",
  WorkflowsNativeExcelScientificNotation = "WorkflowsNativeExcelScientificNotation",
  WorkflowsNativeExcelHyperlinks = "WorkflowsNativeExcelHyperlinks",
  ImporterAcceptedFileExtensions = "ImporterAcceptedFileExtensions",
  WorkflowsPdfExtractionAttribution = "WorkflowsPdfExtractionAttribution",
  StaleVersionBannerThresholdMinutes = "StaleVersionBannerThresholdMinutes",
  WorkflowsBreakpoint = "WorkflowsBreakpoint",
}

export enum PermanentFeature {
  Importer = "Importer",
  CodeHooksApi = "CodeHooksApi",
  IncreasedCodeHookTimeout = "IncreasedCodeHookTimeout",
}
